import React from 'react';
import { readValue } from '../../../../components/InputField/helper';
import { variantClass } from '../../../../util/variant';

const EMPTY = '—';

const toTemplateKey = (field) => (typeof field === 'string' ? field.replace(/\[\d+\]/g, '[]') : field);
const arrayIndexOf = (field) => {
    const match = typeof field === 'string' ? field.match(/\[(\d+)\]/) : null;
    return match ? Number(match[1]) : null;
};

const optionLabel = (jsonField, value) => {
    const options = jsonField?.options;
    if (!Array.isArray(options)) return null;
    const match = options.find((o) => (o && typeof o === 'object' ? o.value === value : o === value));
    if (!match) return null;
    return typeof match === 'object' ? (match.label ?? match.value) : match;
};

const displayValue = (jsonField, dataObj, arrayIndexing) => {
    const raw = readValue(dataObj, jsonField?.field, arrayIndexing);

    if (raw === null || raw === undefined || raw === '') return EMPTY;

    if (typeof raw === 'boolean') return raw ? 'Yes' : 'No';

    if (Array.isArray(raw)) {
        if (!raw.length) return EMPTY;
        return raw
            .map((v) => optionLabel(jsonField, v) ?? (typeof v === 'object' ? null : v))
            .filter((v) => v !== null && v !== undefined && v !== '')
            .join(', ') || EMPTY;
    }

    if (typeof raw === 'object') return EMPTY;

    return optionLabel(jsonField, raw) ?? String(raw);
};

const ReadOnlyFieldGrid = ({
    fieldOrder = [],
    fieldMap = {},
    data,
    arrayIndexing = null,
    defaultFieldClassName = 'col-12',
    rowClassName = 'row gx-4 business-v2-field-grid',
    dataTestId = 'business-v2-readonly-grid',
    variant,
}) => {
    const orderedFields = Array.isArray(fieldOrder) ? fieldOrder : [];
    if (!orderedFields.length) return null;

    const gridVariant = variantClass(variant);

    return (
        <div className={`${rowClassName}${gridVariant ? ` ${gridVariant}` : ''}`} data-testid={dataTestId}>
            {orderedFields.map((field) => {
                const directMatch = fieldMap?.[field];
                const jsonField = directMatch ?? fieldMap?.[toTemplateKey(field)];
                if (!jsonField?.uiType) return null;

                const resolvedIndexing = directMatch ? arrayIndexing : (arrayIndexOf(field) ?? arrayIndexing);

                return (
                    <div
                        key={field}
                        className={`${jsonField?.uiClassName || defaultFieldClassName} business-v2-field-grid__item`}
                    >
                        <div className="docfirst__ro">
                            <div className="docfirst__ro-label">{jsonField?.label || field}</div>
                            <div className="docfirst__ro-value">
                                {displayValue(jsonField, data, resolvedIndexing)}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ReadOnlyFieldGrid;

